import { Component, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { TranslationService } from '@sdbn/common';
import { AbstractWidgetComponent } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';

@Component({
  selector: 'app-visitor-registration-masterdata',
  templateUrl: './visitor-registration-masterdata.component.html',
  styleUrls: ['./visitor-registration-masterdata.component.scss']
})
export class VisitorRegistrationMasterdataComponent extends AbstractWidgetComponent implements OnInit {

  masterdataForm = new FormGroup({});

  constructor(
    public translationService: TranslationService
  ) {
    super();

    this.masterdataForm.addControl('name', new FormControl(null, [Validators.required]));
    this.masterdataForm.addControl('firstname', new FormControl(null, [Validators.required]));
    this.masterdataForm.addControl('company', new FormControl(null, [Validators.required]));
    this.masterdataForm.addControl('numberplate', new FormControl(null, [Validators.required]));
    this.masterdataForm.addControl('reasonForVisit', new FormControl(null, [Validators.required]));
    this.masterdataForm.addControl('visitedPerson', new FormControl(null, [Validators.required]));
    this.masterdataForm.addControl('entranceBarrierSecuredAreaNeeded', new FormControl(null, []));

  }

  ngOnInit(): void {
  }

  onContextChange(contextChange: ContextChange) { }

  onSetElementAndContext() {

    const values: any = {};
    values.name = this.dashboardContext.getContextValue('lastname');
    values.firstname = this.dashboardContext.getContextValue('firstname');
    values.company = this.dashboardContext.getContextValue('company');
    values.numberplate = this.dashboardContext.getContextValue('numberPlate');
    values.reasonForVisit = this.dashboardContext.getContextValue('reasonForVisit');
    values.visitedPerson = this.dashboardContext.getContextValue('visitedPerson');
    if (values.visitedPerson != null && values.visitedPerson.trim().length > 0) {
      this.masterdataForm.controls.visitedPerson.disable();
    }
    values.entranceBarrierSecuredAreaNeeded = this.dashboardContext.getContextValue('entranceBarrierSecuredAreaNeeded');
    this.masterdataForm.reset(values);
    this.dashboardContext.setContextValue('visitorMasterdataValidityState', this.masterdataForm.valid);

    this.masterdataForm.valueChanges.subscribe(
      value => {
        this.dashboardContext.setContextValue('lastname', this.masterdataForm.controls.name.value);
        this.dashboardContext.setContextValue('firstname', this.masterdataForm.controls.firstname.value);
        this.dashboardContext.setContextValue('company', this.masterdataForm.controls.company.value);
        if (!this.masterdataForm.controls.numberplate.disabled) {
          this.dashboardContext.setContextValue('numberPlate', this.masterdataForm.controls.numberplate.value);
        } else {
          this.dashboardContext.setContextValue('numberPlate', null);
        }
        this.dashboardContext.setContextValue('reasonForVisit', this.masterdataForm.controls.reasonForVisit.value);
        this.dashboardContext.setContextValue('visitedPerson', this.masterdataForm.controls.visitedPerson.value);
        this.dashboardContext.setContextValue('entranceBarrierSecuredAreaNeeded', this.masterdataForm.controls.entranceBarrierSecuredAreaNeeded.value);
        this.dashboardContext.setContextValue('needsAreaAccess', this.masterdataForm.controls.entranceBarrierSecuredAreaNeeded.value);
        this.dashboardContext.setContextValue('visitorMasterdataValidityState', this.masterdataForm.valid);
      }
    );
  }

}
